/* template */
<template>
<div class="app"><mpx-keep-alive><router-view class="page"></router-view></mpx-keep-alive></div></template>

/* styles */
<style mpxStyleOptions='{"mid":"mpx-app-scope"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  import '@mpxjs/webpack-plugin/lib/runtime/base.styl'
  import Vue from 'vue'
  import VueRouter from 'vue-router'
  import Mpx from '@mpxjs/core'
  Vue.use(VueRouter)
  global.getApp = function(){}
  global.getCurrentPages = function(){
    if(!global.__mpxRouter) return []
    // @ts-ignore
    return global.__mpxRouter.stack.map(item => {
      let page
      const vnode = item.vnode
      if(vnode && vnode.componentInstance) {
        page = vnode.tag.endsWith('mpx-tab-bar-container') ? vnode.componentInstance.$refs.tabBarPage : vnode.componentInstance
      }
      return page || { route: item.path.slice(1) }
    })
  }
  global.__networkTimeout = undefined
  global.__mpxGenericsMap = {}
  global.__mpxOptionsMap = {}
  global.__style = "v1"
  global.__mpxPageConfig = undefined
  global.__mpxTransRpxFn = undefined
  const wxsModules = {}
  global.currentModuleId = "mpx-app-scope"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./app.mpx.js?isApp!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./app.mpx?ctorType=app&index=0&isApp&lang=js&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mpx-app-scope"]
  export default processOption(
    currentOption,
    "app",
    "index",
    "",
    {},
    // @ts-ignore
    {'index':getComponent(require("./index.mpx?isFirst&isPage"), { __mpxPageRoute: "index" })},
    // @ts-ignore
    {'mpx-keep-alive':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-keep-alive.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true,
    Vue,
    VueRouter
  )
</script>
